export default "__VITE_ASSET__BxK7dV1S__"